module.exports = "15424c14d84c9e051b50e1bb218e5189.wav";


//////////////////
// WEBPACK FOOTER
// ./assets/sfx/hurt_echo.wav
// module id = 92
// module chunks = 0